import type { ProjectUser } from '@/models/projectUser';
import { CombinedUser } from './getCombinedProjectUsers';

export const findCombinedUser = <T extends ProjectUser | CombinedUser>(
    users: T[],
    lesson: {
        responsible_user_id?: number | null;
        external_responsible_user_id?: number | null;
        responsible_ms_user_id?: number | null;
    }
) => {
    const foundUser = users.find((user) => {
        if (
            lesson.responsible_user_id &&
            user.user_id === lesson.responsible_user_id &&
            !user.isExternalUser &&
            !user.isMsUser
        ) {
            return true;
        }
        if (
            lesson.external_responsible_user_id &&
            user.user_id === lesson.external_responsible_user_id &&
            user.isExternalUser &&
            !user.isMsUser
        ) {
            return true;
        }
        return !!(
            lesson.responsible_ms_user_id &&
            user.user_id === lesson.responsible_ms_user_id &&
            user.isExternalUser &&
            user.isMsUser
        );
    });

    return foundUser || null;
};
